import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './Component/Header';
import About from './Pages/About';
import Services from './Pages/Services';
import Contacts from './Pages/Contacts';
import HomeSection from './Pages/Home';
import SubServicePage from './Pages/SubService';

function App() {
  return (
    <BrowserRouter>
      <Header />

      <Routes>
        <Route path="/" element={<HomeSection />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/:slug" element={<SubServicePage />} />
        <Route path="/contacts" element={<Contacts />} />
      </Routes>

    </BrowserRouter>
  );
}

export default App;
